export default {
  locale: 'fa-ir',
  title: 'فارسی',
  strings: {
    'row' : 'ردیف',
    'used.rsee': 'آرسی استفاده شده',
    'remained.of.rsee':'آرسی باقیمانده',
    'reservation.code':'کد رزرو',
    'type' : 'نوع',
    'cafe': 'کافه',
    'table': 'میز',
    'capacity': 'ظرفیت:',
    'person': 'نفر',
    'persons': 'نفره',
    'please.enter.your.number': 'لطفا شماره موبایل خود را وارد کنید',
    'title.easy.reserve': 'به راحتی تو کافه مورد علاقه ات جا رزرو کن',
    'rsee.policy': 'قوانین و مقررات آرسی ',
    'cancelation.policy':"مقررات کنسل کردن رزرو",
    'accept.policy': 'قوانین را خواندم و قبول دارم',
    'enter.verification.code': 'کد تایید را وارد کنید',
    'verification.code.for.mobile.number': 'کد تایید برای شماره ',
    'code.has.sent': 'ارسال گردید',
    'code.does.not.sent': 'پیامکی دریافت نکردید؟',
    'send.code.again': 'ارسال مجدد',
    'edit.mobile.number': 'اصلاح شماره موبایل',
    'login': 'ورود',
    'login.and.register': 'ورود و ثبت نام',
    'forget.password': 'فراموش کرده ام',
    'set.password.for.your.accont':
      'در صورت تمایل می توانید برای حساب کاربری خود، کلمه عبور تعریف کنید',
    'set.new.password.for.your.accont.please':
      'لطفا برای حساب کاربری خود، کلمه عبور جدید تعریف کنید',
    'not.interested': 'تمایل ندارم',
    'register': 'ثبت',
    'header.news': 'تو این روزای سرد بیا کافه وین یه قهوه بزن. یک جمله جدیداضاقه شد',
    'cafes.near.you': 'کافه های اطراف شما',
    'best.cafes': 'کافه های برتر',
    'exit': 'خروج از حساب کاربری',
    'back': 'بازگشت',
    'favorites': 'مورد علاقه ها',
    'you.dont.have.any.favorites.to.show':
      'شما در حال حاضر آیتمی در مورد علاقه ها جهت نمایش ندارید.',
    'you.dont.have.any.comments.to.show':
      'شما در حال حاضر آیتمی درنظرهای من جهت نمایش ندارید.',
    'you.dont.have.any.message.to.show':
      'شما در حال حاضر آیتمی در پیام ها جهت نمایش ندارید.',
    'payment.report': 'گردش حساب',
    'filter.by.payment.type': 'فیلتر براساس نوع تراکنش',
    'filter': 'فیلتر',
    'payments.list': 'لیست تراکنش ها',
    'credit': 'موجودی',
    'cafe.name': 'نام کافه',
    'city.name': 'شهر',
    'state.name': 'استان',
    'address': 'آدرس',
    'cafe.phone.number': 'شماره تماس کافه',
    'first.name': 'نام',
    'last.name': 'نام خانوادگی',
    'first.name.and.last.name': 'نام و نام خانوادگی',
    'phone.number': 'شماره تماس',
    'email.address': 'آدرس ایمیل',
    'email': 'ایمیل',
    'are.you.cafe.owner': 'آیا شما مالک کافه هستید؟',
    'yes': 'بله',
    'no': 'خیر',
    'submit.information': 'ثبت اطلاعات',
    'your.request.submited.successfully': 'درخواست شما با موفقیت ثبت شد. هزینه ی ثبت نام پس از بررسی درخواست، از طریق پیامک برای شما ارسال می گردد.',
    'payment.tracking.number': 'کد پیگیری پرداخت',
    'cafe.menu': 'منو',
    'reserve': 'رزرو',
    'comments': 'نظرات',
    'response': 'پاسخ',
    'cafe.details': 'جزییات کافه',
    'tables.location': 'موقعیت مکانی میز ها',
    'close': 'بستن',
    'cafe.services': 'امکانات کافه',
    'breakfast.served.in.selected.hour':
      'در این ساعت صبحانه سرو می شود. آیا مایل به صرف صبحانه هستید؟',
    'lunch.served.in.selected.hour':
      'در این ساعت ناهار سرو می شود. آیا مایل به صرف ناهار هستید؟',
    'dinner.served.in.selected.hour':
      'در این ساعت شام سرو می شود. آیا مایل به صرف شام هستید؟',
    'your.current.credit': 'اعتبار شما',
    'desired.amount':
      'مبلغ مورد نظر',
    'choose.the.amount.you.wanna.pay':
      'مبلغ مورد نظر برای افزایش اعتبار را انتخاب/وارد کنید',
    'enter.amount.in.toman':
      'لطفا مبلغ مورد نظر خود را به تومان در کادر زیر وارد نمایید',
    'payable.amount':
      'مبلغ قابل پرداخت',
    'increase.credit': 'افزایش اعتبار',
    'other.amounts': 'مبالغ دیگر',
    'temporary.order': 'سفارش موقت',
    'temporary.order.does.not.create.an.obligation.for.the.cafe':
      'سفارش موقت، تعهدی برای کافه ایجاد نمی کند',
    'please.select.your.table.and.hour':
      'لطفا میز و ساعت مورد نظر خود را انتخاب کنید.',
    'confirm': 'تایید',
    'total.entrance.amount.per.hour': 'مبلغ ورودی به ازای هر ساعت',
    'cafe.base.price': 'مبلغ پیش پرداخت',
    'accept': 'می پذیرم',
    'give.up': 'منصرف شدم',
    'see': 'مشاهده',
    'dear.user.this.is.your.reserve.info':
      'گرامی، شما در حال رزرو کافه با مشخصات زیر هستید:',
    'more.information': 'اطلاعات بیشتر',
    'time.to.pay': 'مهلت پرداخت',
    'cancel.reserve': 'لغو رزرو',
    'attention.cafe.base.price.will.decrease.from.your.factor':
      'توجه: مبلغ پیش پرداخت، حداقل میزان سفارش شما در کافه است، که از مبلغ فاکتور شما در کافه کسر می گردد.',
    'pay.reserve.amount': 'پرداخت',
    'dissuasion': 'انصراف',
    'do.you.have.discount.code': 'کد تخفیف دارید؟',
    'apply.discount': 'تایید کد',
    'apply.filter': 'اعمال فیلتر',
    'working.hours': 'ساعات کاری',
    'meals': 'وعده های غذایی',
    'cafe.address': 'آدرس کافه',
    'base.price.for.person.in.hour': 'پیش پرداخت رزرو ساعتی هر نفر',
    'cafe.information': 'اطلاعات کافه',
    'to': 'الی',
    'event': 'رویداد',
    'reserve.type': 'نوع رزرو',
    'reserve.cancellation.terms': 'شرایط کنسل کردن رزرو',
    'cancellation.terms': 'شرایط کنسلی',
    'cancel.terms.before.one.hour':
      'در صورت کنسل کردن رزرو تا یک ساعت مانده به شروع رزرو 100% مبلغ پیش پرداخت مسترد می گردد.',
    'cancel.terms.after.one.hour':
      'در صورت کنسل کردن رزرو از یک ساعت تا ده دقیقه مانده به شروع رزرو 50% مبلغ پیش پرداخت مسترد می گردد.',
    'credit.payment': 'پرداخت از اعتبار',
    'online.payment': 'پرداخت به صورت آنلاین',
    'increase.credit': 'افزایش اعتبار',
    'reserve.payment': 'پرداخت هزینه ی رزرو',
    'errors.title': 'خطا !',
    'warning.title': 'هشدار !',
    'you.dont.have.any.reserves.to.show':
      'شما در حال حاضر آیتمی در رزروهای من جهت نمایش ندارید.',
    'error.yuo.cant.cancel.reserve.in.less.than.one.hour.before.reserve': 'یک ساعت قبل از رزرو امکان لغو وجود ندارد. ',
    'reserve.status': 'وضعیت رزرو:',
    'reserve.code': 'کد رزرو:',
    'reserve.details': 'جزییات رزرو',
    'additionals.amount': 'اضافات',
    'hourly.discounts.amount': 'مبلغ تخفیف ساعتی',
    'discount.code.amount': 'مبلغ کد تخفیف',
    'total': 'مجموع',
    'do.you.want.to.cancel.this.reserve': 'آیا می خواهید رزرو فعلی را لغو کنید؟',
    'success.reserve.payment': 'رزرو شما با موفقیت ثبت شد. تا دقایقی دیگر تاییدیه کافه نیز ارسال می گردد.',
    'success.payment': 'پرداخت با موفقیت انجام شد.',
    'error.payment': 'پرداخت با خطا روبرو شد!',
    'reserve.code': 'کد رزرو',
    'my.reserves': 'رزروهای من',
    'user.profile': 'حساب کاربری',
    'select.avatar':"انتخاب پروفایل",
    'insert.picture': 'افزودن تصویر',
    'edit.picture': 'تغییر تصویر',
    'increase.your.credit.by.complete.profile': 'با تکمیل اطلاعات، اعتبار خود را افزایش دهید.',
    'mobile.number': 'شماره موبایل',
    'birth.date': 'تاریخ تولد',
    'gender': 'جنسیت',
    'marital.status': 'وضعیت تاهل',
    'marriage.date': 'تاریخ ازدواج',
    'add.your.email': 'ایمیل خود را وارد کنید',
    'set.password': 'تنظیم کلمه عبور',
    'change.password': 'تغییر کلمه عبور',
    'delete.picture': 'حذف تصویر',
    'current.password': 'کلمه عبور فعلی',
    'new.password': 'کلمه عبور جدید',
    'repeat.new.password': 'تکرار کلمه عبور جدید',
    'new.reserve': 'رزرو جدید',
    'show.all.cafes': 'نمایش کافه ها',
    'Auto.cancelation.reserve.by.timeout': 'به علت پایان مدت زمان شما، رزرو بطور خودکار لغو شد.',
    'error.min.password.length': 'حداقل طول کلمه عبور، باید 6 کاراکتر باشد',
    'repeated.password.incorrect': 'تکرار کلمه ی عبور صحیح نیست!',
    'messages.list': 'لیست پیام ها',
    'messages': 'پیام ها',
    'you.dont.have.any.ticket': 'در حال حاضر آیتمی در پشتیبانی جهت نمایش ندارید.',
    'send.ticket.to.connect.support.team': 'جهت ارتباط با پشتیبانی، لطفا تیکت ارسال نمایید.',
    'unread.tickets': 'تیکت خوانده نشده:',
    'telephone.number': 'تلفن تماس:',
    'new.ticket': 'تیکت جدید',
    'title': 'عنوان',
    'message.content': 'متن پیام',
    'send': 'ارسال',
    'status': 'وضعیت:',
    'answer.to.ticket': 'پاسخ به تیکت',
    'my.comments': 'نظرهای من',
    'add.comment': 'اکنون نظر دهید',
    'completely.satisfied': 'کاملا راضی',
    'satisfied': 'راضی',
    'middle': 'متوسط',
    'unhappy': 'ناراضی',
    'totally.unhappy': 'کاملا ناراضی',
    'send.comment': 'ارسال نظر',
    'error.title.please.selecet.score.by.select.icons': 'لطفا با انتخاب یکی از آیکن های موجود، میزان رضایت خود را مشخص کنید.',
    'error.title.please.enter.your.comment': 'لطفا نظر خود را در کادر "ثبت نظر" وارد کنید.',
    'apply.discount.code.successfully': 'کد تخفیف با موفقیت اعمال شد',
    'please.read.and.confirm.the.policy': 'لطفا قوانین و مقررات آرسی را مطالعه و تایید فرمایید.',
    'copy.discount.code': 'کپی کردن کد',
    'special.copy':'کد اختصاصی:',
    'copy': 'کپی',
    'Can.be.used.up': 'قابل استفاده تا',
    'to.more.days': 'روز دیگر',
    'Geolocation.error.title': 'خطای موقعیت مکانی',
    'Your.browser.does.not.support.Geolocation': 'مرورگر شما از موقعیت جغرافیایی پشتیبانی نمی کند.',
    'Geolocation.is.not.enabled': 'موقعیت جغرافیایی فعال نیست.',
    'filters': 'فیلترها',
    'search.more': 'جست و جوی بیشتر',
    'cafe.search': 'جست و جوی نام کافه',
    'region.search': 'جست و جوی محله',
    'region': 'محله',
    'cafe.amenities': 'امکانات کافه',
    'main.meals': 'وعده غذایی',
    'cafe.type': 'نوع کافه',
    'cafes.has.discount': 'کافه های دارای تخفیف',
    'cafes.has.event': 'کافه های دارای رویداد',
    'search': 'جست و جو',
    'choose.your.cafes': 'کافه های مورد نظر خود را انتخاب کنید.',
    'choose.your.regions': 'محله های مورد نظر خود را انتخاب کنید.',
    'choose.your.amenities': 'امکانات مورد نظر خود را انتخاب کنید.',
    'choose.your.meals': 'وعده های غذایی مورد نظر خود را انتخاب کنید.',
    'continue': 'ادامه',
    'no.data.to.show': ' متاسفانه، داده ای برای نمایش وجود ندارد.',
    'working.time': 'تایم کاری ',
    'to': 'تا ',
    'view.more': 'مشاهده بیشتر',
    'view.invoice': 'مشاهده صورت حساب',
    'view.cafe': 'مشاهده کافه',
    'wellcoming.text': 'پیام خوش آمدگویی',
    'home': 'خانه',
    'packages': 'بسته ها',
    'reserves': 'رزروها',
    'profile': 'پروفایل',
    'dear.user.wellcome.to.Rsee': ' عزیز به آرسی خوش آمدید.',
    'wating.reserve': 'در انتظار تایید',
    'finished.reserve': 'تمام شده',
    'rejected.reserve': 'رد شده',
    'canceled.reserve': 'لغو شده',
    'client.does.not.came': 'عدم مراجعه',
    'choose.package': 'انتخاب بسته',
    'buy.package.to.savings': 'برای صرفه جویی در هزینه رزروها بسته خریداری کنید.(هر صندلی برابر یک آرسی می باشد.)',
    'each.chair.equal.to.one.rsee': 'هر صندلی برابر یک آٰرسی می باشد.',
    'edit.information': 'ویرایش اطلاعات',
    'membership.request': 'درخواست عضویت کافه',
    'basic.information': 'اطلاعات اولیه',
    'further.information': 'اطلاعات تکمیلی',
    'about.us': 'درباره ما',
    'about.rsee': 'درباره آرسی',
    'rsee.website': 'رفتن به سایت آرسی',
    'invite.friends': 'دعوت از دوستان',
    'invite.your.friends': 'دوستاتو دعوت کن',
    'invite.your.friends.and.gave.them.Rsee':'با دعوت دوستات، بهشون آرسی هدیه بده.',
    'reserve.now': 'اکنون رزرو کنید!',
    'show.on.map': 'نمایش روی نقشه',
    '360.view':'نمای 360درجه',
    'share.invitation.link.with.your.friends.to.join.us': 'لینک اختصاصی که در زیر نمایش داده شده را از طریق شبکه های اجتماعی برای دوستان خود بفرستید تا آن ها دراپلیکیشن ما ثبت نام کنند.',
    'for.what.day': 'برای چه روزی؟',
    'for.what.hour': 'برای چه ساعتی؟',
    'optional.description': 'توضیحات اختیاری',
    'select.table': 'انتخاب میز',
    'write.for.us': 'برامون بنویس...',
    'rsee': 'آرسی',
    'packages.transaction': 'تراکنش بسته ها',
    'my.packages': 'بسته های من',
    'your.reserve': 'رزرو شما',
    'check.your.reserve.details.before.pay': 'جزییات رزروتون رو ببینید در صورت تایید دکمه پرداخت رو بزنید',
    'day': 'روز',
    'date': 'تاریخ',
    'from.time': 'از ساعت',
    'to.time': 'تا ساعت',
    'option': 'آپشن',
    'number.of.persons': 'تعداد',
    'location': 'جایگاه',
    'cost.without.package': 'هزینه بدون بسته',
    'cost.reserve':"هزینه رزرو",
    'cost.inter.price':"مبلغ ورودی",
    'cost.base.price':"مبلغ پیش پرداخت",
    'cost.total':"جمع پرداختی",
    'cost.with.package': 'هزینه با بسته',
    'equivalent':"معادل",
    'by.package.pay':"از بسته شما",

    'pay.by.package': 'پرداخت از بسته',
    'online.pay': 'پرداخت آنلاین',
    'says': 'میگه:',
    'pay.by.credit': 'پرداخت از کیف پول',
    'package': 'بسته',
    'charge.package': 'شارژ بسته',
    'allow.smoking': 'سیگار آزاد',
    'has.cooling.system': 'سیستم سرمایشی',
    'has.fog.system': 'مه پاش',
    'have.heat.system': 'سیستم گرمایشی',
    'support': 'پشتیبانی',
    'description': 'توضیحات',
    'submit.ticket': 'ثبت تیکت',
    'select.city': 'انتخاب شهر',
    'please.select.your.city': 'لطفا شهر مورد نظر خود را انتخاب کنید:',
    'logout': 'خروج',
    'user.register': 'ثبت نام',
    'please.write.your.name': 'لطفا اسم و فامیلت رو واسمون بنویس!',
    'do.you.want.to.logout': 'آیا میخواهید از حساب کاربری خود خارج شوید؟',
    'success.buy': 'خرید موفقیت آمیز',
    'please.enter.your.invitation.code.if.you.have': 'در صورت داشتن معرف، لطفا کد معرفتون رو وارد کنید.',
    'input.amount': 'هزینه ورودی:',
    'toman': 'تومان',
    'request.result': 'نتیجه ی درخواست',
    'charging.active.package': 'شارژ بسته ی فعال',
    'please.enter.cafe.name': 'لطفا نام کافه را وارد نمایید',
    'please.enter.desired.province': 'لطفا استان مورد نظر خود را وارد نمایید',
    'please.enter.cafes.instagram': 'لطفا آیدی اینستاگرام کافه را وارد نمایید',
    'please.enter.desired.city': 'لطفا شهر مورد نظر خود را وارد نمایید',
    'please.enter.cafes.phone.number': 'لطفا تلفن تماس کافه را وارد نمایید',
    'please.enter.cafes.address': 'لطفا آدرس کافه را وارد نمایید',
    'please.enter.your.email': 'لطفا ایمیل خود را وارد نمایید',
    'find.your.favourite.cafe': 'کافه مورد علاقتو پیدا کن',
    'what.was.the.thing.about.this.cafe.you.were.intrested.in': 'چه چیزی در این کافه برای شما جذاب بود؟',
    'cafes.features': 'ویژگی های کافه',
    'you.are.allowed.to.choose.only.two.consecutive.hours': 'شما مجاز به انتخاب تنها دو ساعت متوالی هستید.',
    'invitation.code': 'کد معرف',
    'please.enter.your.first.name': 'لطفا نام را وارد نمایید',
    'please.enter.your.last.name': 'لطفا نام خانوادگی را وارد نمایید',
    'not.enough.credit': 'اعتبار شما کافی نیست!',
    'cafe.instagram.id': ' آیدی اینستاگرام کافه',
    'number.of.tables': 'تعداد میزهای کافه',
    'accept.the.registration.rules.of.the.cafe': 'متن توافق نامه را مطالعه کردم و آن را می پذیرم.',
    'viewing.the.cafe.registration.contract': 'مشاهده ی توافق نامه ثبت نام کافه',
    'registration.fee.toman': 'هزینه ی ثبت نام (تومان)',
    'contract.duration.month': 'مدت قرارداد اولیه (ماه)',
    '': '',
    '': '',
    '': '',
  },
};
